import { Row, Col } from 'react-simple-flex-grid';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import plusIcon from '../images/plus-icon.svg';
import '../styles/HomeStoryBehind.scss';

export const HomeStoryBehind = ({
  isCardContainer,
}: {
  isCardContainer?: boolean;
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const fortuneTellerFirst =
    'https://www.youtube.com/watch?v=SIE2IdBquWU&list=PL0jiIBuf0E6u6kwTdENd1kvPGz5zjBMT7&index=20&ab_channel=SoftServe';
  const fortuneTellerSecond = 'https://www.youtube.com/watch?v=gbUxgw37qPU';

  const openVideo = (link: string) => {
    window.open(link, '_blank');
  };

  const navigate = useNavigate();

  return (
    <>
      <div
        ref={ref}
        className={
          inView ? 'story-behind-wrapper slideInUp' : 'story-behind-wrapper'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <div className="video-blocks-container">
          <Row align="bottom">
            <Col xs={12} sm={6}>
              <div className="video-block">
                <div className="video-block-thumb thumb_1"></div>
                <div className="video-block-footer">
                  {isCardContainer && (
                    <p className="footer-subtitle">
                      Alnair debuted at Web Summit 2022 — captivating the
                      audience with its innovation.
                    </p>
                  )}
                  <div className="footer-actions">
                    <div
                      className="footer-action"
                      onClick={() => openVideo(fortuneTellerFirst)}
                    >
                      <h5 className="footer-title">WATCH THE DEMO</h5>
                      <div className="play-button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 35 35"
                          fill="none"
                        >
                          <circle cx="17.5" cy="17.5" r="17" stroke="white" />
                          <path
                            d="M22.5 16.134C23.1667 16.5189 23.1667 17.4811 22.5 17.866L16.5 21.3301C15.8333 21.715 15 21.2339 15 20.4641L15 13.5359C15 12.7661 15.8333 12.285 16.5 12.6699L22.5 16.134Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <div className="video-block">
                <div className="video-block-thumb thumb_2"></div>
                <div className="video-block-footer">
                  {isCardContainer && (
                    <p className="footer-subtitle">
                      A behind-the-scenes look at how we built the first release
                      of Alnair.
                    </p>
                  )}
                  <div className="footer-actions">
                    <div
                      className="footer-action"
                      onClick={() => openVideo(fortuneTellerSecond)}
                    >
                      <h5 className="footer-title">PEEK BEHIND THE SCENES</h5>
                      <div className="play-button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 35 35"
                          fill="none"
                        >
                          <circle cx="17.5" cy="17.5" r="17" stroke="white" />
                          <path
                            d="M22.5 16.134C23.1667 16.5189 23.1667 17.4811 22.5 17.866L16.5 21.3301C15.8333 21.715 15 21.2339 15 20.4641L15 13.5359C15 12.7661 15.8333 12.285 16.5 12.6699L22.5 16.134Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {isCardContainer && (
          <div className="cards-container">
            <Row gutter={40} className="cards-row">
              <Col xs={12} md={6}>
                <div className="card" onClick={() => navigate('/contact-us')}>
                  <div className="card-title">let’s create together</div>
                  <p className="card-description">
                    Immersive experiences engage customers, create long lasting
                    memories, and cement brand recognition. Let’s build yours
                    today.
                  </p>
                  <div className="card-link">
                    <img src={plusIcon} alt="plus-icon" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <a
                  className="card"
                  href="https://www.softserveinc.com/en-us/services"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="card-title">Our expertise</div>
                  <p className="card-description">
                    Learn more about SoftServe and how we work with our clients!
                  </p>
                  <div className="card-link">
                    <img src={plusIcon} alt="plus-icon" />
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        )}
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
    </>
  );
};
